import ExposedLocationVisitList from "."
import { compose } from "recompose"
import { graphql } from "@apollo/client/react/hoc"
import gql from "graphql-tag"

const ExposedLocationVisitListEnhanced = compose(
  graphql(
    gql`
      query ContactTracingExposedLocationVisits(
        $locationId: ID!
        $startAt: String!
        $endAt: String!
      ) {
        location(id: $locationId) {
          id
          contactTracingVisits(startAt: $startAt, endAt: $endAt) {
            edges {
              node {
                id
                duration
                user {
                  id
                  name
                }
                entryAt
                exitAt
              }
            }
          }
        }
      }
    `,
    {
      options: ({ locationId, startAt, endAt }) => ({
        variables: { locationId, startAt, endAt },
      }),
      props: ({ data: { error, loading, location } }) => {
        if (error) throw error
        if (loading) return { loading }

        return {
          visits: location.contactTracingVisits.edges.map((edge) => ({
            duration: edge.node.duration,
            entryAt: edge.node.entryAt,
            exitAt: edge.node.exitAt,
            userId: edge.node.user.id,
            userName: edge.node.user.name,
          })),
        }
      },
    }
  )
)(ExposedLocationVisitList)

export default ExposedLocationVisitListEnhanced
